export var EnvironmentStage;
(function (EnvironmentStage) {
    EnvironmentStage["DEV"] = "dev";
    EnvironmentStage["PROD"] = "prod";
    EnvironmentStage["ALPHA"] = "alpha";
    EnvironmentStage["BETA"] = "beta";
    EnvironmentStage["GAMMA"] = "gamma";
    EnvironmentStage["UNKNOWN"] = "unknown";
})(EnvironmentStage || (EnvironmentStage = {}));
export var RenderingTypes;
(function (RenderingTypes) {
    RenderingTypes[RenderingTypes["ssr"] = 0] = "ssr";
    RenderingTypes[RenderingTypes["csr"] = 1] = "csr";
})(RenderingTypes || (RenderingTypes = {}));
export var ProfileSections;
(function (ProfileSections) {
    ProfileSections[ProfileSections["User"] = 0] = "User";
    ProfileSections[ProfileSections["Emails"] = 1] = "Emails";
    ProfileSections[ProfileSections["Community"] = 2] = "Community";
    ProfileSections[ProfileSections["Interests"] = 3] = "Interests";
    ProfileSections[ProfileSections["Work"] = 4] = "Work";
    ProfileSections[ProfileSections["Communications"] = 5] = "Communications";
})(ProfileSections || (ProfileSections = {}));
//# sourceMappingURL=types.js.map